// @flow
import styles from './Suburbs.less';

import React, { Component } from 'react';
import NavLink from 'src/components/NavLink/NavLink';
import { ChevronIcon, TextLink, Text } from 'seek-style-guide/react';
import omit from 'lodash/omit';

const initiallyVisibleSuburbs = 5;

type Props = {
  searchQuery: SearchParams,
  suburbs: Array<string>
};

function removePage(query) {
  return omit(query, ['page']);
}

export default class Suburbs extends Component<Props> {
  props: Props;

  renderSuburb(
    searchQuery: SearchParams,
    length: number,
    suburb: string,
    index: number
  ) {
    return (
      <li key={index} className={styles.suburb}>
        <Text raw small>
          <NavLink
            component={TextLink}
            className={styles.link}
            location={{
              pathname: '/jobs',
              query: { ...removePage(searchQuery), where: suburb }
            }}
            aria-label={`Jobs in ${suburb}`}
            analytics="search-by-suburb-clicked"
            data-automation="suburb-link"
          >
            {suburb}
          </NavLink>
          {index !== length - 1 ? <span>,&nbsp;</span> : null}
        </Text>
      </li>
    );
  }

  render() {
    const { suburbs, searchQuery } = this.props;

    if (!suburbs.length || suburbs.length < 2) {
      return null;
    }

    const topSuburbs = suburbs.slice(0, initiallyVisibleSuburbs);
    const remainingSuburbs = suburbs.slice(initiallyVisibleSuburbs);

    return (
      <div className={styles.content} data-automation="suburbs-container">
        <Text small className={styles.heading}>
          <h2>Refine by location</h2>
        </Text>
        <input id="expandSuburbs" type="checkbox" className={styles.toggle} />
        <ul className={styles.suburbs}>
          {topSuburbs.map((suburb, index) =>
            this.renderSuburb(searchQuery, topSuburbs.length, suburb, index)
          )}
          {remainingSuburbs.length ? (
            <label
              htmlFor="expandSuburbs"
              className={`${styles.link} ${styles.toggleLabel}`}
            >
              <Text small>
                <span className={styles.more}>More</span>
                <span className={styles.less}>Less</span>
                <ChevronIcon
                  direction="down"
                  className={styles.chevron}
                  svgClassName={styles.chevronSvg}
                />
              </Text>
            </label>
          ) : null}
          {remainingSuburbs.length ? (
            <div className={styles.toggleContent}>
              {remainingSuburbs.map((suburb, index) =>
                this.renderSuburb(
                  searchQuery,
                  remainingSuburbs.length,
                  suburb,
                  index
                )
              )}
            </div>
          ) : null}
        </ul>
      </div>
    );
  }
}
